/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_New_Share_CreatedInputs */

const en_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New share created`)
};

const fr_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau partage créé`)
};

const de_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Aktie erstellt`)
};

const it_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova condivisione creata`)
};

const ru_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создана новая акция`)
};

const es_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva acción creada`)
};

const zh_cn2_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建了新份额`)
};

const ja_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい共有が作成されました`)
};

const hi_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया शेयर बनाया गया`)
};

const pt_pt2_team_share_new_share_created = /** @type {(inputs: Team_Share_New_Share_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova partilha criada`)
};

/**
* | output |
* | --- |
* | "New share created" |
*
* @param {Team_Share_New_Share_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_new_share_created = /** @type {((inputs?: Team_Share_New_Share_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_New_Share_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_new_share_created(inputs)
	if (locale === "de") return de_team_share_new_share_created(inputs)
	if (locale === "it") return it_team_share_new_share_created(inputs)
	if (locale === "ru") return ru_team_share_new_share_created(inputs)
	if (locale === "es") return es_team_share_new_share_created(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_new_share_created(inputs)
	if (locale === "ja") return ja_team_share_new_share_created(inputs)
	if (locale === "hi") return hi_team_share_new_share_created(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_new_share_created(inputs)
	return en_team_share_new_share_created(inputs)
});